// @ts-nocheck
import React from 'react'
import { connect } from 'react-redux'
import Actions from '../../../actions'
import Operations from '../../../operations'
import Selectors from '../../../selectors'
import { find } from 'lodash'
import { isBrowser, isTablet } from 'react-device-detect'
import { REACT_SWITCH_PROPS } from '../../../common/constants'
import { sizes, colors } from '@lmc/common/constants'
import { Spinner } from '../../generic'
import { CarePlanSummaryHeader, RiskAssessmentsSection } from '../../carePlans'
import Form from '..'
import FormFields from '../FormFields'
import { InitialAssessmentPreview } from '../../../screens/Residents/screens/ResidentInitialAssessmentScreens/components'
import Switch from 'react-switch'
import InitialAssessmentPdfExport from '../../pdf/InitialAssessmentPdfExport'
import { ButtonOLD } from '@lmc/ui-kit'
import Glyph from '../../../LEGACY/Glyph'
import { withRouter } from '../../../withRouter'
import { history } from '../../../store'
import { CAREPLAN_ADL_PBS_ID } from '@lmc/common/types'

interface InitialAssessmentEditFormProps {
  fetchInitialAssessment: (id: string) => void
  initialAssessment: Record<string, any>
  addForm: (initial: Record<string, any>) => void
  fetchList: (listName: string, options: Record<string, any>) => void
  router: {
    params: {
      pre_assessment_id: string
      id: string
    }
  }
  fields: Record<string, any>
  updateItem: (options: Record<string, any>) => void
  showToast: (options: Record<string, any>) => void
  carePlanNominative: Record<string, any>
  remove: (options: Record<string, any>) => void
  resident: Record<string, any>
  carers: Record<string, any>
  riskAssessments: Record<string, any>
  setFormField: (field: string, value: any) => void
  openRiskAssessmentModal: (previous: Record<string, any>) => void
  features: Record<string, any>
  pbsFlagEnabled?: boolean
}

class InitialAssessmentEditForm extends React.Component<InitialAssessmentEditFormProps> {
  private form: any

  constructor(props: InitialAssessmentEditFormProps) {
    super(props)
    this.form = null
    this.state = {
      riskAssessments: null,
      isShowingPreview: false,
    }
  }

  setFormRef = (node: any) => (this.form = node)

  componentDidMount() {
    const {
      fetchInitialAssessment,
      initialAssessment,
      addForm,
      fetchList,
      router: {
        params: { pre_assessment_id, id },
      },
    } = this.props

    if (!initialAssessment) {
      fetchInitialAssessment(pre_assessment_id)
    } else {
      addForm(initialAssessment.formData || {})
    }
    fetchList('risk-assessments', { resident: id })
  }

  componentDidUpdate(prevProps: InitialAssessmentEditFormProps) {
    const { addForm, initialAssessment } = this.props
    if (!prevProps.initialAssessment && initialAssessment) {
      addForm(initialAssessment.formData || {})
    }
  }

  togglePreview = () => {
    this.setState((prevState) => ({
      isShowingPreview: !prevState.isShowingPreview,
    }))
  }

  handleSubmit = (status: string) => {
    const { fields, initialAssessment, updateItem, pbsFlagEnabled } = this.props

    const isPBSAssessment =
      pbsFlagEnabled && initialAssessment.carePlanAdl.id === CAREPLAN_ADL_PBS_ID

    updateItem({
      url: `list/initial-assessments/${initialAssessment.id}`,
      json: {
        formData: fields,
        riskAssessments: fields.riskAssessments,
        strengths: initialAssessment.strengths,
        needs: initialAssessment.needs,
        ...(isPBSAssessment && {
          sections: [
            {
              key: 'baselineBehaviour',
              value: initialAssessment.baselineBehaviour,
            },
            {
              key: 'behaviourEscalation',
              value: initialAssessment.behaviourEscalation,
            },
            {
              key: 'crisisPoint',
              value: initialAssessment.crisisPoint,
            },
          ],
        }),
        status,
      },
      onComplete: this.handleComplete,
      onError: () => {
        this.form && this.form.scrollIntoView({ behavior: 'smooth' })
      },
    })
  }

  handleComplete = () => {
    const {
      router: {
        params: { id },
      },
      showToast,
      initialAssessment: { carePlanAdl },
    } = this.props

    showToast({ title: `Updated ${carePlanAdl.name}` })
    history.push(`/residents/${id}/initial-assessments`)
  }

  handleCancel = () => {
    const {
      router: {
        params: { id },
      },
      remove,
    } = this.props

    remove({
      onConfirm: () => history.push(`/residents/${id}/initial-assessments`),
    })
  }

  residentIsCorrectStatus = () => {
    const { resident } = this.props
    return (
      resident &&
      (resident.status === 'pre-assessment' ||
        resident.isActiveInitialAssessment)
    )
  }

  renderHeader = () => {
    const { errors, initialAssessment, carePlanNominative, resident } =
      this.props
    return (
      <div style={styles.headerContainer}>
        <CarePlanSummaryHeader
          carePlan={initialAssessment}
          carer={initialAssessment.editedBy}
          rightSection={() => (
            <InitialAssessmentPdfExport
              carer={initialAssessment.editedBy}
              id="initial-assessment-pdf-download-button"
              resident={resident}
              initialAssessment={initialAssessment}
              title={`${resident.name.first} ${resident.name.last} - ${initialAssessment.carePlanAdl.name}`}
            />
          )}
          errors={errors}
          onClickBack={this.handleCancel}
          isInitialAssessment
          carePlanNominative={carePlanNominative}
        />
      </div>
    )
  }

  renderFooter = () => {
    if (!this.residentIsCorrectStatus()) return null

    return (
      <div
        className="lmc-fixed-footer"
        style={{
          ...styles.footer,
        }}
      >
        <span style={styles.switchText}>Preview document</span>
        <Switch
          onChange={this.togglePreview}
          checked={this.state.isShowingPreview}
          onColor={colors.green}
          offColor={colors.darkgrey}
          {...REACT_SWITCH_PROPS}
        />
        <ButtonOLD
          style={styles.draftButton}
          onClick={() => this.handleSubmit('draft')}
          type="secondary"
          icon={<Glyph name="pencil" />}
        >
          Save as draft
        </ButtonOLD>
        <div style={styles.buttonDivider} />
        <ButtonOLD
          onClick={() => this.handleSubmit('done')}
          type="primary"
          icon={<Glyph name="check" />}
        >
          Save as done
        </ButtonOLD>
      </div>
    )
  }

  renderForm = () => {
    const { fields, form } = this.props
    const isReadOnly = !this.residentIsCorrectStatus()

    return (
      <div>
        <FormFields
          noLeftMargin
          form={form}
          formId={FORM_ID}
          fields={fields}
          readOnly={isReadOnly}
          style={styles.formFields}
          userGenerated
        />
      </div>
    )
  }

  render() {
    const { fields, resident, initialAssessment, form, features } = this.props

    if (!features || !features.carePlans) return null
    if (!form || !fields || !resident || !initialAssessment) return <Spinner />

    return (
      <div ref={this.setFormRef}>
        <div style={styles.wrapper}>
          {this.renderHeader()}
          <div style={styles.mainContainer}>
            {this.state.isShowingPreview ? (
              <InitialAssessmentPreview initialAssessment={initialAssessment} />
            ) : (
              this.renderForm()
            )}
          </div>
        </div>
        {this.renderFooter()}
      </div>
    )
  }
}

const FORM_ID = 'editInitialAssessment'

const styles = {
  buttonDivider: {
    background: colors.darkgrey,
    height: 31,
    margin: '0px 15px',
    width: 1,
  },
  mainContainer: {
    paddingTop: 5,
    paddingBottom: 24,
  },
  draftButton: {
    marginLeft: 24,
  },
  formFields: {},
  headerContainer: {
    paddingTop: 20,
  },
  footer: {
    alignItems: 'center',
    border: 'none',
    display: 'flex',
    justifyContent: 'flex-end',
    width: isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw',
  },
  switchText: {
    color: colors.darkgrey,
    display: 'block',
    lineHeight: '24px',
    marginRight: 10,
  },
  wrapper: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    paddingBottom: 50,
  },
}

const mapStateToProps = (
  state: Record<string, any>,
  props: Record<string, any>
) => ({
  riskAssessments: state.data['risk-assessments'],
  carers: state.data.carers,
  features: state.global.home,
  form: Selectors.formatFieldsForAssessment(state, props),
  initialAssessment: Selectors.getInitialAssessment(state, props),
  resident: find(state.data.residents, { id: props.router.params.id }),
  carePlanNominative: state.global.home.preferredCarePlansNominative,
})

const mapDispatchToProps = (dispatch: (action: any) => void) => ({
  fetchInitialAssessment: (id: string) =>
    dispatch(Operations.loadListItem('initial-assessments', id)),
  addForm: (initial: Record<string, any>) =>
    dispatch(
      Actions.addForm({
        formId: FORM_ID,
        initial,
      })
    ),
  openRiskAssessmentModal: (previous: Record<string, any>) => {
    dispatch(
      Actions.openModal({
        modalId: 'createRiskAssessment',
        data: { previous, targetFormId: FORM_ID }, // TODO: fix this!
      })
    )
  },
})

const wrappedForm = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InitialAssessmentEditForm)
)

export default Form(wrappedForm, FORM_ID)
